import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import {
  resetBackAndCup,
  resetAllChanges,
  resetCup,
  resetSizeAndCaches,
  setBackChange,
  setBackSize,
  setBackSizes,
  setCachedBackSize,
  setCachedCupSize,
  setCountry,
  setCupChange,
  setCupSize,
  setCupSizes,
  setGoToStageEight,
  setNextStage,
  setPartTwoSelected,
  setPrevStage,
  setSelected,
  setTempBackCache,
  setTempCupCache,
  toggleCountry,
  togglePartTwo,
  toggleQuiz,
} from 'shared/actions/size-quiz';

import BraFitFinder from '../../../../bra-fit-finder/components/BraFitFinder';
import { getStageButtonData } from '../../../../bra-fit-finder/data/stageButtonData';
import { stageProps } from '../../../../bra-fit-finder/utils/helpers';
import { stagesCompiler } from '../../../../bra-fit-finder/utils/stagesComplier.js';
import UnsuccessfulStage from '../../../../bra-fit-finder/components/stages/UnsuccessfulStage';

const SizeQuiz = props => {
  useEffect(() => {
    props.setCountry(props.locale);
  }, [props.locale]);

  const {
    defaultButtonProps,
    defaultNextProps,
    defaultPreviousProps,
  } = stageProps({
    cupSize: props.cupSize,
    resetSelected: props.setSelected,
    selected: props.buttonSelected,
    setPrevStage: props.setPrevStage,
    setNextStage: props.setNextStage,
    setSelected: props.setSelected,
    stageNumber: props.stageNumber,
  });

  const stageButtonData = getStageButtonData({
    country: props.country,
    cupChange: props.cupChange,
    goToStageEight: props.goToStageEight,
    setBackChange: props.setBackChange,
    setBackSize: props.setBackSize,
    setCupChange: props.setCupChange,
    setCupSize: props.setCupSize,
    setGoToStageEight: props.setGoToStageEight,
    setPartTwoSelected: props.setPartTwoSelected,
    togglePartTwo: props.togglePartTwo,
    tempBackCache: props.tempBackCache,
    tempCupCache: props.tempCupCache,
  });

  const stages = stagesCompiler({
    defaultButtonProps,
    defaultPreviousProps,
    defaultNextProps,
    stageButtonData,
    ...props,
  });

  return (
    <BraFitFinder
      {...props}
      stages={stages}
      unsuccessfulStage={<UnsuccessfulStage contactData={props.contactData} />}
    />
  );
};

const mapDispatchToProps = dispatch => ({
  resetBackAndCup: (tempBackCache, tempCupCache) =>
    dispatch(resetBackAndCup(tempBackCache, tempCupCache)),
  resetAllChanges: () => dispatch(resetAllChanges()),
  resetCup: cupSize => dispatch(resetCup(cupSize)),
  resetSizeAndCaches: () => dispatch(resetSizeAndCaches()),
  setBackChange: numberOfSizes => dispatch(setBackChange(numberOfSizes)),
  setBackSize: size => dispatch(setBackSize(size)),
  setBackSizes: size => dispatch(setBackSizes(size)),
  setCachedBackSize: size => dispatch(setCachedBackSize(size)),
  setCachedCupSize: size => dispatch(setCachedCupSize(size)),
  setCountry: country => dispatch(setCountry(country)),
  setCupSize: size => dispatch(setCupSize(size)),
  setCupSizes: size => dispatch(setCupSizes(size)),
  setCupChange: numberOfSizes => dispatch(setCupChange(numberOfSizes)),
  setGoToStageEight: payload => dispatch(setGoToStageEight(payload)),
  setNextStage: numberOfSteps => dispatch(setNextStage(numberOfSteps)),
  setPartTwoSelected: id => dispatch(setPartTwoSelected(id)),
  setPrevStage: numberOfSteps => dispatch(setPrevStage(numberOfSteps)),
  setSelected: id => dispatch(setSelected(id)),
  setTempBackCache: payload => dispatch(setTempBackCache(payload)),
  setTempCupCache: payload => dispatch(setTempCupCache(payload)),
  toggleCountry: country => dispatch(toggleCountry(country)),
  togglePartTwo: payload => dispatch(togglePartTwo(payload)),
  toggleQuiz: payload => dispatch(toggleQuiz(payload)),
});

const mapStateToProps = ({ app, footer, sizeQuiz }) => {
  // Get contact components from footerContainer and filter out 'Virtual Fitting'
  const contactData =
    footer.length > 0
      ? [{ ...footer.siteFooterContainers[0], hideTitle: true }]
      : [];
  const filteredContactData =
    contactData.length > 0
      ? (contactData[0].rows[0].items = footer.siteFooterContainers[0].rows[0].items.filter(
          contactType => contactType.title !== 'Virtual Fitting'
        ))
      : [];

  return {
    backChange: sizeQuiz.backChange,
    backSize: sizeQuiz.backSize,
    backSizes: sizeQuiz.backSizes,
    basePath: app.config.basePath,
    brand: sizeQuiz.brand,
    buttonSelected: sizeQuiz.buttonSelected,
    cachedBackSize: sizeQuiz.cachedBackSize,
    cachedCupSize: sizeQuiz.cachedCupSize,
    contactData: filteredContactData,
    country: sizeQuiz.country,
    cupChange: sizeQuiz.cupChange,
    cupSize: sizeQuiz.cupSize,
    cupSizes: sizeQuiz.cupSizes,
    displayQuiz: sizeQuiz.displayQuiz,
    goToStageEight: sizeQuiz.goToStageEight,
    locale: app.locale.selected,
    partTwoButtonSelected: sizeQuiz.partTwoButtonSelected,
    showPartTwo: sizeQuiz.showPartTwo,
    stageNumber: sizeQuiz.stageNumber,
    tempBackCache: sizeQuiz.tempBackCache,
    tempCupCache: sizeQuiz.tempCupCache,
    tooltip: sizeQuiz.tooltip,
  };
};

SizeQuiz.propTypes = {
  backChange: PropTypes.number,
  buttonSelected: PropTypes.number,
  contactData: PropTypes.array,
  country: PropTypes.string,
  cupChange: PropTypes.number,
  cupSize: PropTypes.string,
  locale: PropTypes.string,
  goToStageEight: PropTypes.bool,
  setCupChange: PropTypes.func,
  setCupSize: PropTypes.func,
  setBackChange: PropTypes.func,
  setBackSize: PropTypes.func,
  setCountry: PropTypes.func,
  setGoToStageEight: PropTypes.func,
  setNextStage: PropTypes.func,
  setPartTwoSelected: PropTypes.func,
  setPrevStage: PropTypes.func,
  setSelected: PropTypes.func,
  setTempBackCache: PropTypes.func,
  stageNumber: PropTypes.number,
  tempBackCache: PropTypes.string,
  tempCupCache: PropTypes.object,
  togglePartTwo: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(SizeQuiz);
